import L from 'leaflet'

/**
 * Ensures a singleton Leaflet map is initialized in #osmMapContainer.
 * Exposes it as window.leafletMap.
 */
export function ensureLeafletMap() {
  if (window.leafletMap) return window.leafletMap
  const containerId = 'osmMapContainer'
  const container = document.getElementById(containerId)
  if (!container) return null
  window.leafletMap = L.map(containerId, {scrollWheelZoom: false}).setView([34.72383109685586, 135.45281896187524], 9)
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(window.leafletMap)
  return window.leafletMap
}

export default ensureLeafletMap
